<template>
  <div class="tw-bg-gray-100 tw-px-4 tw-py-2 tw-border-b tw-border-gray-200 tw-font-medium">
    <slot />
  </div>
</template>

<script setup lang="ts">
  defineOptions({ name: 'UiCardHeader' })
</script>
